import { apiClient } from "../../apiClient";
import { ApiResponse } from "../../../types/api";
import {
  GameTable,
  CreateGameTableRequest,
  UpdateGameTableRequest,
  GetGameTablesParams,
  GetGameTablesResponse,
} from "./type";

class GameTableService {
  private transformGameTable(apiTable: GameTable): GameTable {
    return {
      id: apiTable.id,
      name: apiTable.name,
      minAmount: apiTable.minAmount,
      maxAmount: apiTable.maxAmount,
      isLimit: apiTable.isLimit,
      limitNumber: apiTable.limitNumber,
      gameId: apiTable.gameId,
      activePlayers: apiTable.activePlayers,
      createdAt: apiTable.createdAt,
      updatedAt: apiTable.updatedAt,
      isActive: apiTable.isActive,
      createdBy: apiTable.createdBy,
      updatedBy: apiTable.updatedBy,
    };
  }

  async getGameTables(
    params: GetGameTablesParams = {},
  ): Promise<GetGameTablesResponse> {
    const queryParams = new URLSearchParams();
    if (params.skip !== undefined)
      queryParams.append("skip", params.skip.toString());
    if (params.limit !== undefined)
      queryParams.append("limit", params.limit.toString());
    if (params.search) queryParams.append("search", params.search);

    const response = await apiClient.get<{
      success: boolean;
      data: {
        gameTables: GameTable[];
        total: number;
        skip: number;
        limit: number;
      };
    }>(`/game-tables/?${queryParams.toString()}`);

    return {
      gameTables:
        response.data.data.gameTables?.map((table: GameTable) =>
          this.transformGameTable(table),
        ) || [],
      total: response.data.data.total || 0,
      skip: response.data.data.skip || 0,
      limit: response.data.data.limit || 25,
    };
  }

  async getGameTable(id: string): Promise<GameTable> {
    const response = await apiClient.get<ApiResponse<GameTable>>(
      `/game-tables/${id}`,
    );
    return this.transformGameTable(response.data.data);
  }

  async createGameTable(data: CreateGameTableRequest): Promise<GameTable> {
    const response = await apiClient.post<ApiResponse<GameTable>>(
      "/game-tables/",
      data,
    );
    return this.transformGameTable(response.data.data);
  }

  async updateGameTable(
    id: string,
    data: UpdateGameTableRequest,
  ): Promise<GameTable> {
    const response = await apiClient.put<ApiResponse<GameTable>>(
      `/game-tables/${id}`,
      data,
    );
    return this.transformGameTable(response.data.data);
  }

  async deleteGameTable(id: string): Promise<void> {
    await apiClient.delete(`/game-tables/${id}`);
  }
}

export const gameTableService = new GameTableService();
